module.exports = "/assets/a7d0a161261e09f58601ac1af64b6f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GK.png
// module id = 1408
// module chunks = 0